import { ELEMENT_PARAGRAPH } from '@udecode/plate';
import {
  getEditorString,
  insertNodes,
} from '@udecode/plate-common';

import { NOTE_HEADER, NOTE_HEADER_VOID } from './createNoteLayoutPlugin';

export const withNoteLayout = (
  editor,
) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    if (path.length === 0) {
      // Add the header void if the note is empty or the first node is not a header.
      if (
        editor.children.length === 0 ||
        (editor.children.length === 1 && getEditorString(editor, [0]) === '') ||
        (editor.children[0].type !== NOTE_HEADER &&
        editor.children[0].type !== NOTE_HEADER_VOID)
      ) {
        const header = {
          type: NOTE_HEADER_VOID,
          children: [{ text: '' }],
        };
        insertNodes(editor, header, { at: path.concat(0) });
      }

      if (editor.children.length < 2) {
        const paragraph = {
          type: ELEMENT_PARAGRAPH,
          children: [{ text: '' }],
        };
        insertNodes(editor, paragraph, { at: path.concat(1) });
      }
    }
    return normalizeNode([node, path]);
  };

  return editor;
};
